module.exports = __webpack_public_path__ + "static/media/doormat.b16e1e14.svg";